/** --------------------------------------------------------------------------------------------------------------------
 * @file RatingStart/index.tsx
 * @fileoverview this file will show user rating in dashboard table's
 * @createdBy Arash Goharrostami
 * @createdAt 2025-06-28 Saturday - June 28, 2025
 */

type RatingStarsProps = {
  average: number;
  count: number;
  size?: number;
};

const StarIcon = ({ fill = 0, size = 20 }: { fill: number; size?: number }) => {
  const gradientId = `grad-${Math.random()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scaleX(-1)" }}
    >
      <defs>
        <linearGradient id={gradientId}>
          <stop offset={`${fill * 100}%`} stopColor="#ffb300" />
          <stop offset={`${fill * 100}%`} stopColor="#BBB" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2
           9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  );
};

export default function RatingStars({ average, count, size = 20 }: RatingStarsProps) {
  const fullStars = Math.floor(average);
  const remainder = average - fullStars;
  const partialFill = remainder >= 0.01 ? remainder : 0;
  const emptyStars = 5 - fullStars - (partialFill > 0 ? 1 : 0);

  const stars: JSX.Element[] = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<StarIcon key={`full-${i}`} fill={1} size={size} />);
  }

  if (partialFill > 0) {
    stars.push(<StarIcon key="partial" fill={partialFill} size={size} />);
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(<StarIcon key={`empty-${i}`} fill={0} size={size} />);
  }

  return (
    <div style={{padding: '1rem'}}>
      {stars}
      <span className="" style={{paddingRight: '10px', color: 'gray'}}>({count})</span>
    </div>
  );
}
